// @ts-nocheck -- staged migration: add explicit types before removing this directive.
const levelPromiseCache = {};
let kanjiExampleMeaningsPromise = null;

function fetchJson(path, label) {
    return fetch(`${process.env.PUBLIC_URL}${path}`).then((res) => {
        if (!res.ok) throw new Error(`Failed to load ${label} (status ${res.status})`);
        return res.json();
    });
}

// Each JLPT level's word list is a separate static JSON file (built from
// JMdict + a JLPT tag list), fetched on demand and cached in memory so
// switching levels back and forth doesn't re-fetch. PT-PT meanings live in
// a parallel per-level file keyed by word id, fetched only for PT pages.
export function fetchVocabularyLevel(level, language = "en") {
    const isPt = language === "pt";
    const key = `${level}-${isPt ? "pt" : "en"}`;
    if (!levelPromiseCache[key]) {
        const english = fetchJson(`/vocab-data/n${level}.json`, `N${level} vocabulary`);
        levelPromiseCache[key] = isPt
            ? Promise.all([english, fetchJson(`/vocab-data/pt/n${level}.json`, `N${level} PT vocabulary`)]).then(
                  ([words, ptMeanings]) =>
                      words.map((word) => ({
                          ...word,
                          englishMeanings: word.meanings,
                          meanings: ptMeanings[word.id] ?? word.meanings,
                      }))
              )
            : english;
        levelPromiseCache[key].catch(() => {
            delete levelPromiseCache[key];
        });
    }
    return levelPromiseCache[key];
}

export function wordMatchesMeaning(word, query) {
    return [...(word.meanings || []), ...(word.englishMeanings || [])].some((meaning) =>
        meaning.toLowerCase().includes(query)
    );
}

export function fetchKanjiExampleMeaningsPt() {
    if (!kanjiExampleMeaningsPromise) {
        kanjiExampleMeaningsPromise = fetchJson("/vocab-data/pt/kanji-examples.json", "PT kanji examples");
        kanjiExampleMeaningsPromise.catch(() => {
            kanjiExampleMeaningsPromise = null;
        });
    }
    return kanjiExampleMeaningsPromise;
}
